import { useEffect } from "react";
import { Sun, Moon, Monitor } from "lucide-react";
import { useThemeStore } from "../../stores/themeStore";

const MODES = [
  { value: "light", icon: Sun, label: "Light" },
  { value: "dark", icon: Moon, label: "Dark" },
  { value: "system", icon: Monitor, label: "System" },
];

/**
 * Compact icon-only toggle that cycles: light → dark → system → light.
 * Shows the icon for the *current* selection.
 *
 * @param {{ className?: string, iconSize?: number }} props
 */
export default function ThemeToggle({ className = "", iconSize = 18 }) {
  const { theme, setTheme } = useThemeStore();

  const cycle = () => {
    const idx = MODES.findIndex((m) => m.value === theme);
    setTheme(MODES[(idx + 1) % MODES.length].value);
  };

  const current = MODES.find((m) => m.value === theme) ?? MODES[0];
  const Icon = current.icon;

  return (
    <button
      onClick={cycle}
      title={`Theme: ${current.label} (click to cycle)`}
      className={`p-2 rounded-lg text-neutral-500 hover:text-primary-600 hover:bg-neutral-100 dark:text-neutral-400 dark:hover:text-primary-400 dark:hover:bg-neutral-800 transition-colors ${className}`}
      aria-label={`Current theme: ${current.label}`}
    >
      <Icon size={iconSize} strokeWidth={1.8} />
    </button>
  );
}
